import React, { type FC, type MouseEvent } from "react";
import { useDispatch } from "react-redux";

import { playgroundModal } from "../../../app/state/pages/WelcomeSlice";

import { Tooltip } from "./Tooltip";

export const TrialTooltip: FC<
	React.PropsWithChildren<{
		disabled?: boolean;
		linkTrackId?: string;
	}>
> = ({ disabled, children, linkTrackId }) => {
	const dispatch = useDispatch();

	const stopBubbling = (evt: MouseEvent) => {
		evt.preventDefault();
		evt.stopPropagation();
	};

	if (disabled) {
		return <>{children}</>;
	}

	return (
		<Tooltip
			title={
				<span className="select-none" onClick={stopBubbling}>
					Available only in the trial.{" "}
					<a
						className="text-white underline visited:text-white hover:text-white hover:no-underline"
						data-trackid={linkTrackId}
						onClick={() => {
							// TODO: STAC-16306 add event (When a tooltip Learn more link or an integration panel is clicked, send a button click event to Google Analytics that encapsulated which button is clicked.)
							dispatch(playgroundModal({ open: true }));
						}}
						role="link"
					>
						Learn more
					</a>
				</span>
			}
		>
			{children}
		</Tooltip>
	);
};
